/* NUTSH LAB (27 Oct 2026): corrector d'errors al correu dels formularis.
   Molts correus que entren pels anuncis reboten perque estan mal escrits
   (gmial.com, hotmal.com, gmail.con...). Cada rebot resta reputacio i fa que
   els nostres emails acabin a Promocions o Spam.
   Que fa: si el domini del correu sembla un error d'un proveidor conegut,
   mostra "Querias decir ...?" sota el camp. El primer envio amb error es
   para un cop perque la persona ho vegi; el segon passa sempre (mai bloqueja
   del tot, per no perdre ningu). Funciona dins dels formularis de Shopify
   Forms (shadow DOM obert) i als camps de correu normals de la pagina. */
(function () {
  var NAMES = {
    gmail: ['com'],
    googlemail: ['com'],
    hotmail: ['com', 'es', 'fr', 'it', 'de', 'co.uk', 'be', 'nl'],
    outlook: ['com', 'es', 'fr', 'it', 'de', 'be'],
    live: ['com', 'es', 'fr', 'it', 'de', 'nl', 'be', 'co.uk'],
    yahoo: ['com', 'es', 'fr', 'it', 'de', 'co.uk'],
    icloud: ['com'],
    protonmail: ['com', 'ch'],
    telefonica: ['net']
  };
  var REAL = ['ymail.com', 'mail.com', 'email.com', 'gmx.com', 'gmx.es', 'gmx.de', 'gmx.net', 'gmx.fr', 'aol.com', 'me.com', 'mac.com', 'msn.com', 'proton.me', 'pm.me', 'zoho.com', 'hotmail.co', 'yahoo.co', 'tutanota.com', 'mail.ru', 'gmal.de'];
  var MIN_FUZZY = 5; /* noms curts (live, msn) nomes es corregeixen pel domini final */

  /* distancia d'edicio amb transposicions (gmial -> gmail = 1) */
  function lev(a, b) {
    if (a === b) return 0;
    var m = a.length, n = b.length, i, j, d = [];
    for (i = 0; i <= m; i++) { d[i] = [i]; }
    for (j = 0; j <= n; j++) { d[0][j] = j; }
    for (i = 1; i <= m; i++) {
      for (j = 1; j <= n; j++) {
        var c = a[i - 1] === b[j - 1] ? 0 : 1;
        d[i][j] = Math.min(d[i - 1][j] + 1, d[i][j - 1] + 1, d[i - 1][j - 1] + c);
        if (i > 1 && j > 1 && a[i - 1] === b[j - 2] && a[i - 2] === b[j - 1]) d[i][j] = Math.min(d[i][j], d[i - 2][j - 2] + 1);
      }
    }
    return d[m][n];
  }

  function fixTld(t) {
    var map = { con: 'com', cmo: 'com', comm: 'com', coom: 'com', cpm: 'com', vom: 'com', xom: 'com', ocm: 'com', om: 'com', cm: 'com', co: 'com', 'com.': 'com', ese: 'es', 'es.': 'es', ner: 'net', nte: 'net' };
    return map[t] || t;
  }

  /* Torna el correu corregit, o null si no hi ha res a corregir. */
  function suggest(email) {
    var v = (email || '').trim().toLowerCase();
    var at = v.lastIndexOf('@');
    if (at < 1) return null;
    var user = v.slice(0, at), dom = v.slice(at + 1);
    if (!dom) return null;
    var name, tld, dot = dom.indexOf('.');
    if (dot === -1) {
      /* "gmailcom" o "gmail" */
      for (var k in NAMES) {
        if (dom === k) { name = k; tld = NAMES[k][0]; break; }
        if (dom === k + NAMES[k][0]) { name = k; tld = NAMES[k][0]; break; }
      }
      if (!name) {
        for (var k2 in NAMES) {
          if (k2.length >= MIN_FUZZY && (lev(dom, k2) === 1 || lev(dom, k2 + 'com') === 1)) { name = k2; tld = NAMES[k2][0]; break; }
        }
      }
      return name ? user + '@' + name + '.' + tld : null;
    }
    if (REAL.indexOf(dom) !== -1) return null; /* dominis reals semblants a un conegut */
    name = dom.slice(0, dot); tld = dom.slice(dot + 1);
    if (NAMES[name] && NAMES[name].indexOf(tld) !== -1) return null; /* correcte */
    var best = null;
    if (NAMES[name]) {
      best = name;
    } else if (name.length >= 4) {
      var bestD = 9;
      for (var k3 in NAMES) {
        if (k3.length < MIN_FUZZY) continue;
        var d = lev(name, k3);
        var lim = k3.length >= 7 ? 2 : 1;
        if (d <= lim && d < bestD) { bestD = d; best = k3; }
      }
    }
    if (!best) {
      /* proveidor desconegut: nomes arreglem finals clarament erronis */
      var t2 = fixTld(tld);
      return t2 !== tld && /^(con|cmo|comm|coom|cpm|vom|xom|ocm)$/.test(tld) ? user + '@' + name + '.' + t2 : null;
    }
    var okT = NAMES[best];
    var newT = okT.indexOf(tld) !== -1 ? tld : (okT.indexOf(fixTld(tld)) !== -1 ? fixTld(tld) : okT[0]);
    var out = user + '@' + best + '.' + newT;
    return out === v ? null : out;
  }

  var ES = (document.documentElement.lang || '').toLowerCase().indexOf('es') === 0;
  var TXT = ES
    ? { q: '¿Querías decir ', yes: 'Sí, corregir' }
    : { q: 'Did you mean ', yes: 'Yes, fix it' };

  function setVal(input, val) {
    var proto = Object.getPrototypeOf(input);
    var desc = Object.getOwnPropertyDescriptor(proto, 'value') || Object.getOwnPropertyDescriptor(HTMLInputElement.prototype, 'value');
    if (desc && desc.set) desc.set.call(input, val); else input.value = val;
    input.dispatchEvent(new Event('input', { bubbles: true, composed: true }));
    input.dispatchEvent(new Event('change', { bubbles: true, composed: true }));
  }

  function attach(input) {
    if (input.__nutshEmailCheck) return;
    input.__nutshEmailCheck = true;
    var form = input.closest('form');
    var box = document.createElement('div');
    box.setAttribute('role', 'status');
    box.style.cssText = 'display:none;width:100%;box-sizing:border-box;margin-top:8px;font-size:14px;line-height:1.4;text-align:left;color:inherit;';
    if (form) form.insertAdjacentElement('afterend', box); else input.parentNode.appendChild(box);
    var warned = '';

    function show(s) {
      if (!s) { box.style.display = 'none'; box.textContent = ''; return; }
      if (form) {
        /* el formulari de Shopify Forms es una graella: el missatge va a la mateixa columna que el camp */
        var cs = getComputedStyle(form);
        box.style.gridColumn = cs.gridColumnStart + ' / ' + cs.gridColumnEnd;
        /* mateix color que el text legal del formulari (llegible en fons clar i fosc) */
        var ref = box.parentNode && box.parentNode.querySelector('[class*="isclaimer"]');
        if (ref) box.style.color = getComputedStyle(ref).color;
      }
      box.textContent = '';
      box.appendChild(document.createTextNode(TXT.q));
      var b = document.createElement('strong'); b.textContent = s; box.appendChild(b);
      box.appendChild(document.createTextNode('? '));
      /* enllac i no boto: els estils del formulari pinten tots els botons de negre */
      var btn = document.createElement('a');
      btn.href = '#';
      btn.setAttribute('role', 'button');
      btn.textContent = TXT.yes;
      btn.style.cssText = 'font-weight:600;color:inherit;text-decoration:underline;cursor:pointer;';
      btn.addEventListener('click', function (e) {
        e.preventDefault(); e.stopPropagation();
        setVal(input, s); show(null); input.focus();
      });
      box.appendChild(btn);
      box.style.display = 'block';
    }

    function check() { show(suggest(input.value)); }
    input.addEventListener('blur', check);
    input.addEventListener('input', function () { if (box.style.display === 'block') check(); });

    function guard(e) {
      var s = suggest(input.value);
      if (!s) return;
      if (warned === input.value) return; /* segon intent: deixem passar */
      warned = input.value;
      e.preventDefault();
      e.stopImmediatePropagation();
      show(s);
    }
    if (form) {
      form.addEventListener('submit', guard, true);
      var sub = form.querySelector('button[type="submit"],input[type="submit"]');
      if (sub) sub.addEventListener('click', guard, true);
    }
  }

  function isEmailField(el) {
    if (el.type === 'email') return true;
    var hint = ((el.name || '') + ' ' + (el.getAttribute('autocomplete') || '') + ' ' + (el.getAttribute('placeholder') || '') + ' ' + (el.getAttribute('aria-label') || '') + ' ' + (el.id || '')).toLowerCase();
    if (/mail|correo/.test(hint)) return true;
    var form = el.closest('form');
    return !!(form && /email/i.test(form.textContent || '') && form.querySelectorAll('input[type="text"],input:not([type])').length === 1);
  }

  function scan(root) {
    var els = root.querySelectorAll('input[type="email"],input[type="text"],input:not([type])');
    for (var i = 0; i < els.length; i++) if (isEmailField(els[i])) attach(els[i]);
  }

  function run() {
    scan(document);
    var hosts = document.querySelectorAll('shopify-forms-embed');
    for (var i = 0; i < hosts.length; i++) if (hosts[i].shadowRoot) scan(hosts[i].shadowRoot);
  }

  window.__nutshSuggestEmail = suggest;
  var tries = 0;
  var t = setInterval(function () { tries++; run(); if (tries > 120) clearInterval(t); }, 500);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', run); else run();
})();